var radio = require("react-pubsub-via-radio.js/radio");
var _ = require('lodash');

var RadioMixin = {
	componentDidMount: function(){
		_.each(this.radio, function(callback, key){
			radio(key).subscribe(callback);
		});
	},
	componentWillUnmount: function(){
		_.each(this.radio, function(callback, key){
			radio(key).unsubscribe(callback);
		});
	}
};

module.exports = RadioMixin;



//////////////////
// WEBPACK FOOTER
// ./~/ES/utils/RadioMixin.js
// module id = 21
// module chunks = 0 1 2 3 4